export * from './IconFileConfig';
